var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":_vm.disable ? 'presentation' : 'button'},on:{"click":_vm.showCommentsPanel}},[_c('div',{class:[
      'flex',
      {
        'items-end': !_vm.isUsedInPostExpandedView,
        'items-center': _vm.isUsedInPostExpandedView,
      },
      {
        'text-dark-text-200': _vm.colorScheme === 'light',
        'text-light-text-200': _vm.colorScheme === 'dark',
      } ]},[_c('OzIcon',{attrs:{"name":"comment_outline","size":_vm.iconSize}}),_vm._v(" "),_c('span',{class:[
        {
          'ms-0.5': !_vm.isUsedInPostExpandedView,
          'ms-1': _vm.isUsedInPostExpandedView,
        },
        {
          'text-12-16 font-sans': !_vm.isUsedInPostExpandedView,
          'text-body-small': _vm.isUsedInPostExpandedView,
        },
        {
          'text-dark-text-200': _vm.colorScheme === 'light',
          'text-light-text-200': _vm.colorScheme === 'dark',
        } ]},[_vm._v(_vm._s(_vm.commentsListLength))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }